module.exports = __webpack_public_path__ + "static/media/YB5M04_1.a8fab5f8.jpg";